<template>

    <div class="modal" tabindex="-1" role="dialog" ref="modalElement" id="dialog_modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">

                <div class="modal-header"
                     :class="state.headerTitleStyle">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <p v-html="message"></p>
                </div>

                <div class="modal-footer justify-content-center">
                    <button type="button" class="btn btn-secondary"
                            @click="answerCancel">
                        {{ state.cancelText }}
                    </button>
                    <button type="button"
                            class="btn"
                            :class="state.btnStyle"
                            @click="answerOk">
                        {{ state.okText }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref, watch} from 'vue';


import Modal from 'bootstrap/js/dist/modal'
import {useMainStore} from "@/stores/mainStore";


/**
 *
 * - AVAILABLE TYPES:
 *  success - green header
 *  danger - red header
 *  primary - blue header
 *  warn - yellow header
 *  info - info header
 *
 */

export default defineComponent({
    name: 'DialogModal',

    mixins: [],

    setup: function () {
        // console.log('dialog modal context', ctx)
        const modalElement = ref(null)

        const mainStore = useMainStore();

        let myModal: Modal;

        const state = reactive({
            // headerTitleStyle:/*'',*/'text-white bg-primary',
            // headerTitleStyle:/*'',*/'text-white bg-danger',
            headerTitleStyle: computed(() => {
                const type = mainStore.getDialog.type
                switch (type) {
                    case 'success':
                        return 'text-white bg-success'
                    case 'danger':
                        return 'text-white bg-danger'
                    case 'primary':
                        return 'text-white bg-primary'
                    case 'warn':
                        return 'text-white bg-warning'
                    case 'info':
                        return 'text-white bg-info'
                }
                return ''
            }),
            show: computed(() => mainStore.getDialog.show),
            btnStyle: computed(() => {
                let btnStyle = mainStore.getDialog.btnStyle
                if (!btnStyle) {
                    const type = mainStore.getDialog.type
                    switch (type) {
                        case 'danger':
                            btnStyle = 'btn-danger'
                            break
                        case 'info':
                            btnStyle = 'btn-info'
                            break
                        case 'success':
                            btnStyle = 'btn-success'
                            break
                        case 'warn':
                            btnStyle = 'btn-warning'
                            break
                        default:
                            btnStyle = 'btn-primary'
                            break
                    }
                }
                return btnStyle
            }),
            okText: computed(()=> mainStore.getDialog.okText ?? 'Ok'),
            cancelText: computed(()=> mainStore.getDialog.cancelText ?? 'Cancel'),
        })

        onMounted(() => {
            myModal = new Modal('#dialog_modal', {
                keyboard: false
            })
            const element = document.getElementById('dialog_modal');
            if (element) {
                element.addEventListener('hidden.bs.modal', function (/*event*/) {
                    mainStore.showDialog();
                })
            }
        })


        watch(() => mainStore.getDialog.show,
            (val) => {
                val ? myModal.show() : myModal.hide()
            }
        )

        const title = computed(() => mainStore.getDialog.title)
        const message = computed(() => mainStore.getDialog.message)
        const successCallback = computed(() => mainStore.getDialog.successCallback)
        const cancelCallback = computed(() => mainStore.getDialog.cancelCallback)
        const btnStyle = computed(() => mainStore.getDialog.btnStyle)


        function answerOk() {
            if (successCallback.value !== undefined) {
                successCallback.value()
            }
            mainStore.showDialog();
        }

        function answerCancel() {
            if (cancelCallback.value !== undefined) {
                cancelCallback.value()
            }
            mainStore.showDialog();
        }

        return {
            title,
            message,
            state,
            modalElement,
            answerOk,
            answerCancel,
            btnStyle,
        }


    }


})
</script>

<style scoped>
.clickable {
    cursor: pointer;
}
</style>
